// Angular
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// Angular Material
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

// Local library
import { TranslationService } from '@amwager/data-access';
import { TranslatePipe } from '@amwager/util';

/**
 * Data product terms and conditions dialog — renders the Equibase
 * copy shipped with the language packs.
 */
@Component({
  selector: 'feature-mat-program-terms',
  templateUrl: './program-terms.component.html',
  styleUrls: ['./program-terms.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe
  ]
})
export class ProgramTermsComponent {

  private readonly translationService = inject(TranslationService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly dialogRef: MatDialogRef<ProgramTermsComponent> = inject(MatDialogRef);

  /** Pack copy is authored as markup, so it has to bypass sanitizing */
  readonly content: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(
    this.translationService.translate('program.shop.terms.modal.content', '')
  );

  /**
   * Dismiss the dialog
   * @returns {void}
   */
  close(): void {
    this.dialogRef.close();
  }
}
